module.exports = __webpack_public_path__ + "img/deliver-img-4-2.3b63f76d.png";